import { useEffect } from "react";
import useAppHooks from "../../../../../../shared/hooks/useAppHooks";
import RenderMathQuestion from "../../../../../../shared/components/RenderMathQuestion/RenderMathQuestion";
import { optionLables } from "../..";
import "./QuestionCard.css";
import QuestionHeader from "../../Layout/QuestionHeader/QuestionHeader";
import { updateQuestionStatus } from "../../../../../../redux/exam/examSlice";

const QuestionCard = () => {
  const { selector, dispatch } = useAppHooks();

  const state = selector((state) => state.examSlice);
  const currentLang = state?.currentLang || "en";

  useEffect(() => {
    if (state?.question?.[0]?.qid) {
      dispatch(
        updateQuestionStatus({
          qid: state.question[0].qid,
          makeCurrent: true,
        })
      );
    }
  }, [state?.question?.[0]?.qid, dispatch]);

  const handleOptionClick = (optionId) => {
    const currentQid = state.question[0].qid;

    dispatch(
      updateQuestionStatus({
        qid: currentQid,
        selectedOption: optionId,
      })
    );
  };

  return (
    <div className="exam__question_card">
      <QuestionHeader />
      <div className="exam__question_card__question">
        {state?.question?.length && (
          <RenderMathQuestion
            question={
              currentLang === "en"
                ? state?.question?.[0]?.q_text
                : state?.question?.[0]?.q_text_hindi
            }
          />
        )}
      </div>

      <div className="exam__question_card__options">
        {state?.question?.[0]?.option?.map((opt, index) => {
          const currentQ = state.questionsData.find(
            (q) => q.qid === state.question[0].qid
          );

          return (
            <div
              key={opt.option_id}
              className={`exam__question_card__option ${
                currentQ?.selectedOption === opt.option_id ? "selected" : ""
              }`}
              onClick={() => handleOptionClick(opt.option_id)}
            >
              <span
                className={`exam__question_card__option_label ${
                  currentQ?.selectedOption === opt.option_id
                    ? "selected-label"
                    : "not-selected-label"
                }`}
              >
                {optionLables[index]}
              </span>

              <RenderMathQuestion
                question={currentLang === "en" ? opt.option : opt.option_hindi}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default QuestionCard;
